import * as _ from 'lodash';

export class ComplementaryFields {
    field: string;
    required: boolean;
}

export class Roles {
    type: string;
    name: string;
    active: boolean;
    systemic: boolean;
    complementaryFields = new Array<ComplementaryFields>();

    constructor(data: Roles[]) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }
}

export class RoleSearch {
    active: boolean;
    systemic: boolean;

    constructor(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Roles.model.ts